'use strict';

import {
  applyMiddleware,
  compose,
  createStore,
}                         from 'redux';
import {combineReducers}  from 'redux-immutable';
import thunk              from 'redux-thunk';

import langueReducer      from './reducers/langueReducer';
import emailReducer       from './reducers/emailReducer';
import emailOrderReducer  from './reducers/emailOrderReducer';
import calendarReducer    from './reducers/calendarReducer';
import sessonReducer      from './reducers/sessonReducer';

// Redux DevTools Extension
// See https://github.com/zalmoxisus/redux-devtools-extension#12-advanced-store-setup
// for more details of this
const composeEnhancers =
  typeof window === 'object' &&
  window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ?
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
      name: 'GaelleBoudier-store',
      // Specify extension’s options like name, actionsBlacklist, actionsCreators, serialize...
    }) : compose;

const finalCreateStore = composeEnhancers(
  applyMiddleware(thunk),
)(createStore);

const appReducer = combineReducers({
  langue     : langueReducer,
  email      : emailReducer,
  emailOrder : emailOrderReducer,
  calendar   : calendarReducer,
  session    : sessonReducer,
});

const store = finalCreateStore(appReducer);

if (module.hot) {
  // Enable Webpack hot module replacement for reducers
  module.hot.accept(() => {
    store.replaceReducer(appReducer);
  });
}

export default store;



// WEBPACK FOOTER //
// ./src/store/store.js